import { render, staticRenderFns } from "./viewrevoke.vue?vue&type=template&id=1cdd2c0f&scoped=true"
import script from "./viewrevoke.vue?vue&type=script&lang=js"
export * from "./viewrevoke.vue?vue&type=script&lang=js"
import style0 from "./viewrevoke.vue?vue&type=style&index=0&id=1cdd2c0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd2c0f",
  null
  
)

export default component.exports